import { ChangeDetectionStrategy, Component, OnInit, TemplateRef, Type } from '@angular/core';
import { CustomOverlayRef } from '../../../services/custom-overlay.ref';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { NgComponentOutlet, NgTemplateOutlet } from '@angular/common';

type SpinnerContent = string | TemplateRef<unknown> | Type<unknown>;

@Component({
  selector: 'ebeihilfe-spinner',
  standalone: true,
  imports: [MatProgressSpinner, NgComponentOutlet, NgTemplateOutlet],
  templateUrl: './spinner.component.html',
  styleUrl: './spinner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpinnerComponent implements OnInit {
  public contentType: 'template' | 'string' | 'component' = 'string';
  public content: SpinnerContent | undefined;
  public context: { close: () => void } | null = null;

  constructor(private ref: CustomOverlayRef) {}

  public close(): void {
    this.ref.close();
  }

  public ngOnInit(): void {
    this.content = this.ref.content;

    if (typeof this.content === 'string') {
      this.contentType = 'string';
    } else if (this.content instanceof TemplateRef) {
      this.contentType = 'template';
      this.context = {
        close: this.ref.close.bind(this.ref),
      };
    } else {
      this.contentType = 'component';
    }
  }
}
